import React from "react";
import styled, { keyframes } from "styled-components";

import { BhHomepage7Card } from "./BhHomePage7Card";


// 롤링

const scrollLeft = () => keyframes`
  0% {
    transform: translateX(1524px); /* 오른쪽 끝에서 시작 */
  }
  100% {
    transform: translateX(-4256px); /* 왼쪽 끝으로 사라짐 */
  }
`;

// 오른쪽으로 스크롤되는 애니메이션 정의 (contentWidth를 동적으로 처리)
const scrollRight = () => keyframes`
  0% {
    transform: translateX(-4256px); /* 왼쪽 끝에서 시작 */
  }
  100% {
    transform: translateX(1254px); /* 오른쪽 끝으로 사라짐 */
  }
`;


const StyledElement = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  width: 100%;

& .background-image {
    width: 100%;
    object-fit: cover;
}  

& .overlay-content {
    position: relative;
    // margin: 20px auto;
    // padding: 20px;
    z-index: 1;
    display: flex;
    flex-direction: column;
}

& .card-content {
    position: absolute;
    top: 390px;
    height: 544px;
}

& .roll-image {
    height: 260px;
}

  /* View 롤링 애니메이션 스타일 */
  & .view {
    overflow: hidden; /* 스크롤바 숨김 */
    // position: absolute;
  }

  & .view-left {
    display: flex;
    white-space: nowrap;
    animation: ${({ parentWidth, contentWidthLeft }) => {
        console.log("Animation parentWidth:", parentWidth);
        console.log("Animation contentWidth:", contentWidthLeft);
        return scrollLeft(parentWidth, contentWidthLeft);
    }} 50s linear infinite;
  }

  & .view-right {
    display: flex;
    white-space: nowrap;
    animation: ${({ parentWidth, contentWidthRight }) =>
        scrollRight(parentWidth, contentWidthRight)} 50s linear infinite;
  } 

`;


export const BhHomepage7 = () => {

    return (
        <StyledElement>
            <img className="background-image" alt="background-image" src="/image/7page.png" />
            <div className="card-content" >
                <div className="view" >
                    <div className="view-left" >
                        <BhHomepage7Card />
                    </div>
                </div>
                <div style={{ height: '24px' }} />
                <div className="view" >
                    <div className="view-right" >
                        <BhHomepage7Card />
                    </div>
                </div>
            </div>
        </StyledElement>
    );
};
